import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  CommentOutlined,
  DeleteOutlined,
  FileDoneOutlined,
  MinusCircleOutlined,
  NotificationOutlined,
  ToTopOutlined,
  RollbackOutlined,
  QuestionCircleOutlined,
  EyeOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";
import { Button, Col, Modal, Row, Tag } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import BoxContent from "../../../component/Desktop/content";
import Loading from "../../../component/Desktop/loading/loading";
import TitlePage from "../../../component/Desktop/titlePage";
import FooterPage from "../../../component/footer/footerPage";

import TextArea from "antd/lib/input/TextArea";
import { useMediaQuery } from "react-responsive";
import { ApiDisaster } from "../../../api/backend/disaster";
import {
  COMMON_CONSTANT,
  DISASTER_CONVERSATION_TYPE,
  DISASTER_STATUS,
  KEY,
  lang,
  STYLE,
} from "../../../constants/common.const";
import routerConst from "../../../constants/router.const";
import statusConst from "../../../constants/status.const";
import {
  checkErrorDuplicateFileName,
  handleCatchError,
  showMessage,
} from "../../../constants/utils";
import classPopup from "../../../models/control/popup";
import classText from "../../../models/control/text";
import rolesConst from "../../../routers/roles/roles.const";
import ListFeedback from "./listFeedback";
let order = 1;

function ViewDisaster() {
  const { roles } = useSelector((state) => state.auth);

  // check role
  const isOfficeAdmin =
    roles == rolesConst.OFFICE_ADMIN || roles == rolesConst.OFFICE_USER;
  const isHeadOfficeAdmin = roles == rolesConst.HEAD_OFFICE_ADMIN;
  const isAdmin = isOfficeAdmin || isHeadOfficeAdmin;

  const isPC = useMediaQuery({
    query: KEY.LAPTOP_WIDTH,
  });
  const classBtn = isPC
    ? "buttonPC button--info wAuto mr15"
    : "buttonPC button--info w100 mb5";
  const [showLoading, setShowLoading] = useState(false);
  const [nameCategory, setNamefacility] = useState("Category 1");
  const history = useHistory();
  const { id } = useParams();
  const { allowRoute, isLeader } = useSelector((state) => state.auth);
  const location = useLocation();
  const [txtReason, setTxtReason] = useState(new classText());
  const [popupConfirm, setPopupConfirm] = useState(new classPopup());
  const [tblAttach, setTblAttach] = useState([]);
  const [detail, setDetail] = useState({
    id: "",
    siteOfficeMasterName: "",
    name: "",
    categoryId: "",
    category: "",
    status: "",
    statusValue: "",
    note: "",
    conversations: [],
  });

  // ref
  const fileEl = useRef(null);
  const noteRef = useRef();
  const formDataAttach = new FormData();
  let indexFile = 0;

  // read file
  async function readAttachFileUrl(e) {
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    if (file.name) {
      const isErrorNamefile = checkErrorDuplicateFileName(
        file.name,
        tblAttach,
        "attachFileName"
      );
      if (isErrorNamefile) {
        return;
      }
    }
    const formData = new FormData();
    const body = {
      attachFileName: file.name,
      type: 3,
    };
    formData.append("data", JSON.stringify(body));
    formData.append("file", file);
    const fileRes = await ApiDisaster.uploadFile(formData);
    const url = fileRes.data.url;
    const newListAttach = [...tblAttach];
    newListAttach.push({
      itemOrder: order++,
      attachFileUrl: url,
      attachFileName: file.name,
    });
    setTblAttach(newListAttach);

    fileEl.current.value = null;
  }

  let showStatus = (sttCode) => {
    let o;
    statusConst.STATUS_DISASTER.forEach((v) => {
      if (Number(v.key) === Number(sttCode)) {
        o = v;
      }
    });
    if (!o) return;
    return (
      o.label && (
        <Tag color={o.color + "1a"} className="tag-label">
          <span style={{ color: o.color, fontWeight: "bold" }}>
            {detail.statusValue}
          </span>
        </Tag>
      )
    );
  };

  // Change Status

  const changeStatus = async (status) => {
    try {
      setShowLoading(true);
      await ApiDisaster.changeStatus(id, status);
      showMessage(KEY.INFO, COMMON_CONSTANT.BOM_C003, () =>
        getDetailDisaster()
      );
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };

  // FEED BACK
  const onFeedback = async () => {
    if (popupConfirm.isRequiredNote && !txtReason.value.trim()) {
      setTxtReason({ ...txtReason, error: true });
      noteRef.current.focus();
      return;
    } else {
      setTxtReason({ ...txtReason, error: false });
    }
    try {
      setShowLoading(true);
      const dataPostFeedBack = {
        disasterId: id,
        type: popupConfirm.commandId,
        note: txtReason.value,
        attachments: tblAttach,
      };
      !popupConfirm.itemEdit
        ? await ApiDisaster.addFeedBack(dataPostFeedBack, id)
        : await ApiDisaster.updateFeedback(
            dataPostFeedBack,
            id,
            popupConfirm.itemEdit.id
          );
      getDetailDisaster();
      setPopupConfirm({ ...popupConfirm, show: false });
      setTblAttach([]);
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };

  const initPopupFeedback = ({
    title,
    commandId,
    status,
    itemEdit,
    customTitle,
  }) => {
    setPopupConfirm({
      ...popupConfirm,
      show: true,
      title,
      customTitle,
      commandId,
      status,
      itemEdit,
      isRequiredNote:
        commandId === DISASTER_CONVERSATION_TYPE.CONVERSATION_HEADOFFICE ||
        commandId === DISASTER_CONVERSATION_TYPE.CONVERSATION_OFFCIE,
    });
    if (itemEdit) {
      setTxtReason({ ...txtReason, value: itemEdit.note });
      setTblAttach(
        itemEdit.attachments.map((item, index) => ({
          ...item,
          itemOrder: index,
        }))
      );
    }
    getDetailDisaster();
  };
  // Show COnfirm
  const showMessageConfirm = (commandId, itemEdit = null) => {
    // Box reason
    let customTitle = false;
    setTxtReason({ ...txtReason, value: "", error: false });

    let lblConfirmMessagesModal;
    let status;

    if (commandId == DISASTER_CONVERSATION_TYPE.CONFIRM_NO_DAMAGED) {
      lblConfirmMessagesModal = COMMON_CONSTANT.DISASTER_NODAMED_CONFIRM;
      status = DISASTER_STATUS.NODAMAGED;
      customTitle = true;
      initPopupFeedback({
        title: COMMON_CONSTANT.DISASTER_NODAMED_CONFIRM,
        customTitle: customTitle,
        commandId: commandId,
        status,
        itemEdit,
      });
      return;
    }
    if (commandId == DISASTER_CONVERSATION_TYPE.CONFIRM_WAITING) {
      lblConfirmMessagesModal = COMMON_CONSTANT.DISASTER_WAITING_CONFIRM;
      status = DISASTER_STATUS.WAITING;
      customTitle = true;
      initPopupFeedback({
        title: lblConfirmMessagesModal,
        customTitle: customTitle,
        commandId: commandId,
        status,
        itemEdit,
      });
      return;
    } else if (commandId == DISASTER_CONVERSATION_TYPE.CLOSE) {
      status = DISASTER_STATUS.CLOSE;
      lblConfirmMessagesModal = COMMON_CONSTANT.DISASTER_CONFIRM_CLOSE;
    } else if (commandId == DISASTER_CONVERSATION_TYPE.CONFIRM_DAMAGED) {
      status = DISASTER_STATUS.DAMAGED;
      lblConfirmMessagesModal = COMMON_CONSTANT.DISASTER_DAMED_CONFIRM;
      customTitle = true;
      // Show popup confirm
      initPopupFeedback({
        title: COMMON_CONSTANT.DISASTER_DAMED_CONFIRM,
        customTitle: customTitle,
        commandId: commandId,
        status,
        itemEdit,
      });

      return;
    } else if (
      commandId == DISASTER_CONVERSATION_TYPE.CONVERSATION_HEADOFFICE ||
      commandId == DISASTER_CONVERSATION_TYPE.CONVERSATION_OFFCIE
    ) {
      lblConfirmMessagesModal = lang.FEED_BACK;
      customTitle = true;
      // Show popup confirm
      initPopupFeedback({
        title: lang.FEED_BACK,
        customTitle: customTitle,
        commandId: commandId,
        status: null,
        itemEdit,
      });

      return;
    } else if (commandId == DISASTER_CONVERSATION_TYPE.COMPLETE_PROCEDURES) {
      // Empty
      lblConfirmMessagesModal = COMMON_CONSTANT.CONFRIM_COMPLETE_PROCEDURES;
      customTitle = true;
      status = DISASTER_STATUS.COMPLETE_PROCEDURES;

      // Show popup confirm
      initPopupFeedback({
        title: lblConfirmMessagesModal,
        customTitle: customTitle,
        commandId: commandId,
        status,
        itemEdit,
      });
      return;
    } else if (commandId == DISASTER_CONVERSATION_TYPE.FOLLOWING) {
      lblConfirmMessagesModal = COMMON_CONSTANT.CONFRIM_FOLLOWING;
      customTitle = true;
      status = DISASTER_STATUS.FOLLOWING;
      // Show popup confirm
      initPopupFeedback({
        title: lblConfirmMessagesModal,
        customTitle: customTitle,
        commandId: commandId,
        status,
        itemEdit,
      });
      return;
    }

    // Warning
    Modal.confirm({
      centered: true,
      icon: <QuestionCircleOutlined />,
      title: lang.CONFIRM,
      content: lblConfirmMessagesModal,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: () => {
        if (status) {
          changeStatus(status);
        }
      },
    });
  };

  // close modal
  const closeModal = () => {
    setPopupConfirm({ ...popupConfirm, show: false });
    setTxtReason({ ...txtReason, value: "" });
    setTblAttach([]);
  };

  // Show Button
  const showButon = {
    no_damaed: detail.status == DISASTER_STATUS.UNDECIDED && isOfficeAdmin,
    damaed: detail.status == DISASTER_STATUS.UNDECIDED && isOfficeAdmin,
    close:
      isAdmin &&
      (detail.status == DISASTER_STATUS.WAITING ||
        detail.status == DISASTER_STATUS.FOLLOWING ||
        detail.status == DISASTER_STATUS.COMPLETE_PROCEDURES ||
        detail.status == DISASTER_STATUS.NODAMAGED),
    feedback:
      detail.status != DISASTER_STATUS.CLOSE &&
      detail.status != DISASTER_STATUS.UNDECIDED,
    remind: isAdmin && detail.status != DISASTER_STATUS.CLOSE,
    completed: isOfficeAdmin && detail.status == DISASTER_STATUS.DAMAGED,
    following: isAdmin && detail.status == DISASTER_STATUS.COMPLETE_PROCEDURES,
    waiting: detail.status == DISASTER_STATUS.NODAMAGED && isAdmin,
  };
  // detail
  const getDetailDisaster = async () => {
    try {
      const res = await ApiDisaster.getDetailDisaster(id);
      setDetail(res.data);
    } catch (error) {
      if (error.response) {
        if (error.response.status === 404) {
          showMessage(KEY.ERROR, "この災害が存在しません。");
        } else {
          handleCatchError(error);
        }
      }
    }
  };
  useEffect(() => {
    if (id) {
      getDetailDisaster();
    }
  }, [id]);

  // REmind
  const handleRemind = () => {
    Modal.confirm({
      icon: <QuestionCircleOutlined />,
      centered: true,
      title: lang.CONFIRM,
      content: COMMON_CONSTANT.DISASTER_CONFIRM_REMIND,
      okText: lang.OK,
      cancelText: lang.CANCEL,
      onOk: async () => {
        try {
          await ApiDisaster.remind(id);
          showMessage(KEY.INFO, "リマインド成功。");
        } catch (error) {
          handleCatchError(error);
        }
      },
    });
  };

  return (
    <div className="des-content">
      <TitlePage name={lang.DISASTER_VIEW} />
      <BoxContent center>
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <Row>
              <Col lg={4} xs={10}>
                <span className="bold">{lang.STATUS}</span>
                {lang.COLON}
              </Col>
              <Col>{showStatus(Number(detail.status))}</Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row>
              <Col lg={4} xs={10}>
                <span className="bold">{lang.DISASTER_NAME}</span>
                {lang.COLON}
              </Col>
              <Col>{detail.name}</Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row>
              <Col lg={4} xs={10}>
                <span className="bold">{lang.DISASTER_CATEGORY}</span>
                {lang.COLON}
              </Col>
              <Col>
                <Link
                  to={`${routerConst.ROUTER_PAGE.DISASTER_CATEGORY[3]}/${detail.categoryId}`}
                >
                  {" "}
                  {detail.category}
                </Link>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row>
              <Col lg={4} xs={10}>
                <span className="bold">{lang.FACTORY_MAME}</span>
                {lang.COLON}
              </Col>
              <Col>{detail.siteOfficeMasterName}</Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row>
              <Col lg={4} xs={10}>
                <span className="bold">{lang.CREATED_TIME}</span>
                {lang.COLON}
              </Col>
              <Col>{detail.createDatetime}</Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row>
              <Col lg={4} xs={10}>
                <span className="bold">{lang.USER_SELECT_DISASTER}</span>
                {lang.COLON}
              </Col>
              <Col lg={20} xs={14}>
                {detail.notifyTo}
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row>
              <Col lg={4} xs={10}>
                <span className="bold">{lang.NOTE}</span>
                {lang.COLON}
              </Col>
              <Col>{detail.note}</Col>
            </Row>
          </Col>
        </Row>

        <Row
          style={{
            paddingBottom: !isPC && 220,
          }}
        >
          <ListFeedback
            onEditFeedBack={showMessageConfirm}
            getDetailDisaster={getDetailDisaster}
            setShowLoading={setShowLoading}
            listFeedBack={detail.conversations || []}
            status={detail.status}
          />
        </Row>
      </BoxContent>
      <Loading show={showLoading} />
      {isAdmin && (
        <FooterPage>
          <Row gutter={[8, 0]} justify="space-between">
            <Col>
              {showButon.feedback && (
                <Button
                  className={classBtn}
                  onClick={() => {
                    showMessageConfirm(
                      isHeadOfficeAdmin
                        ? DISASTER_CONVERSATION_TYPE.CONVERSATION_HEADOFFICE
                        : DISASTER_CONVERSATION_TYPE.CONVERSATION_OFFCIE
                    );
                  }}
                >
                  <CommentOutlined />
                  {lang.FEED_BACK}
                </Button>
              )}
              {showButon.no_damaed && (
                <Button
                  className={classBtn}
                  onClick={() => {
                    showMessageConfirm(
                      DISASTER_CONVERSATION_TYPE.CONFIRM_NO_DAMAGED
                    );
                  }}
                >
                  <CheckCircleOutlined />
                  {lang.NO_DAMAGED}
                </Button>
              )}
              {showButon.damaed && (
                <Button
                  className={classBtn}
                  onClick={() => {
                    showMessageConfirm(
                      DISASTER_CONVERSATION_TYPE.CONFIRM_DAMAGED
                    );
                  }}
                >
                  <MinusCircleOutlined />
                  {lang.DAMAGED}
                </Button>
              )}
              {showButon.following && (
                <Button
                  className={classBtn}
                  onClick={() => {
                    showMessageConfirm(DISASTER_CONVERSATION_TYPE.FOLLOWING);
                  }}
                >
                  <EyeOutlined />
                  {lang.FOLLOWING}
                </Button>
              )}
              {showButon.waiting && (
                <Button
                  className={classBtn}
                  onClick={() => {
                    showMessageConfirm(
                      DISASTER_CONVERSATION_TYPE.CONFIRM_WAITING
                    );
                  }}
                >
                  <ClockCircleOutlined />
                  {lang.WAITING}
                </Button>
              )}
              {showButon.close && (
                <Button
                  className={classBtn}
                  onClick={() => {
                    showMessageConfirm(DISASTER_CONVERSATION_TYPE.CLOSE);
                  }}
                >
                  <CloseCircleOutlined />
                  {lang.FINISH}
                </Button>
              )}

              {showButon.completed && (
                <Button
                  className={classBtn}
                  onClick={() => {
                    showMessageConfirm(
                      DISASTER_CONVERSATION_TYPE.COMPLETE_PROCEDURES
                    );
                  }}
                >
                  <FileDoneOutlined />
                  {lang.COMPLETE_PROCEDURES}
                </Button>
              )}

              {showButon.remind && (
                <Button onClick={() => handleRemind()} className={classBtn}>
                  <NotificationOutlined />
                  {lang.REMIND}
                </Button>
              )}
              <Button
                className={` buttonPC button--outline`}
                onClick={() => history.push("/Disaster/List")}
              >
                <RollbackOutlined />
                {lang.BACK}
              </Button>
            </Col>
          </Row>
        </FooterPage>
      )}
      {!isAdmin && (
        <FooterPage>
          <Button
            className={` buttonPC button--outline`}
            onClick={() => history.goBack()}
          >
            <RollbackOutlined />
            {lang.BACK}
          </Button>
        </FooterPage>
      )}
      <Modal
        centered
        width={isPC ? 800 : "90%"}
        closeIcon={<></>}
        className="modal-msg"
        title={
          <div>
            {/* <ExclamationCircleOutlined /> */}
            <div style={{}} className="modal-custom-content">
              {popupConfirm.title}
              {popupConfirm.customTitle && (
                <>
                  <Row>
                    <span className="fs12 pt5 mb5">
                      {lang.FEED_BACK}
                      {popupConfirm.isRequiredNote && <label className="blod ml5 mark-required">*</label>}
                    </span>
                  </Row>
                  <Row>
                    <TextArea
                      ref={noteRef}
                      rows={3}
                      className={txtReason.error ? STYLE.BORDER_RED : ""}
                      maxLength={255}
                      value={txtReason.value}
                      onChange={(e) => {
                        setTxtReason({
                          ...txtReason,
                          value: e.target.value,
                          error: false,
                        });
                      }}
                    />
                  </Row>
                  <Row gutter={[8, 8]}>
                    <>
                      <input
                        type="file"
                        className="d-none"
                        ref={fileEl}
                        onChange={readAttachFileUrl}
                      />
                      <Col span={24}>
                        <Button
                          type="link"
                          onClick={() => fileEl.current.click()}
                          className="buttonPC button--outline --todo-- wAuto mt10"
                        >
                          <ToTopOutlined />
                          {lang.ATTACH_FILE}
                        </Button>
                      </Col>

                      <Col span={24}>
                        {tblAttach.length > 0 &&
                          tblAttach.map((item, index) => {
                            let urlFile = item.attachmentUrl;
                            return (
                              <Row
                                className="mb10"
                                key={index}
                                style={{ alignItems: "center" }}
                              >
                                <Col span={2}>
                                  <Button
                                    onClick={() => {
                                      let list = [...tblAttach].filter(
                                        (x) =>
                                          x["itemOrder"] != item["itemOrder"]
                                      );
                                      setTblAttach(list);
                                    }}
                                    className="btn-deletefile mr8"
                                    style={{
                                      background: "#f7f9fc",
                                      minWidth: "unset",
                                      height: 30,
                                    }}
                                    icon={<DeleteOutlined />}
                                  />
                                </Col>
                                <Col>
                                  <a
                                    style={{
                                      fontWeight: "normal",
                                      fontSize: 14,
                                    }}
                                    href={urlFile}
                                  >
                                    {item.attachFileName}{" "}
                                  </a>
                                </Col>
                              </Row>
                            );
                          })}
                      </Col>
                    </>
                  </Row>
                </>
              )}
            </div>
          </div>
        }
        visible={popupConfirm.show}
        footer={[
          <Button
            key={2}
            onClick={() => {
              closeModal();
            }}
          >
            {/* <CloseCircleOutlined /> */}
            {lang.CANCEL}
          </Button>,
          <Button
            onClick={() => onFeedback()}
            key={1}
            className="buttonPC button--warning2 wAuto"
          >
            {lang.OK}
          </Button>,
        ]}
      ></Modal>
    </div>
  );
}

export default ViewDisaster;
